<template>
  <div class="min-h-screen bg-base-100 flex flex-col">
    <!-- Static header (non-sticky) -->
    <MainHeader :isSticky="false" :isMinimal="false" :scrolled="false" />

    <!-- Main content container -->
    <main class="flex-grow w-full">
      <router-view />
    </main>

    <!-- Footer -->
    <Footer />
  </div>
</template>

<script setup lang="ts">
import MainHeader from "@/components/headers/MainHeader.vue";
import Footer from "../components/Footer.vue";
</script>
